import { makeStyles } from '@material-ui/styles'

const clientTicketStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(1.6),
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    overflow: 'auto',
  },
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: theme.spacing(1.6),
  },
  gridContainer: {
    marginTop: theme.spacing(4.0),
  },
  img: {
    width: '100%',
    marginTop: theme.spacing(2.4),
    marginBottom: theme.spacing(4.0),
  },
  formSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  textField: {
    marginBottom: theme.spacing(2.4),
  },
  datePicker: {
    marginTop: theme.spacing(2.4),
    marginBottom: theme.spacing(2.4),
  },
  boldFont: {
    fontWeight: theme.typography.fontWeightBold,
  },
  tableContainer: {
    minWidth: '100%',
  },
  table: {
    marginBottom: theme.spacing(4.0),
  },
  button: {
    marginBottom: theme.spacing(2.4),
  },
}))

export default clientTicketStyles
